import { createSlice } from '@reduxjs/toolkit';
import { camelCase } from 'lodash-es';
import { createAsyncAction } from '../action';

const addStore = createAsyncAction('addStore', 'addStore');
const getStores = createAsyncAction('getStores', 'getStores');
const getStoresDetails = createAsyncAction('getStoresDetails', 'getStoresDetails');

interface IInitialState {
  isAddingStore: boolean;
  isFetchingStores: boolean;
  isFetchingStoreDetails: boolean;
  isStoreAdded: boolean;
  addStoreMsg: any;
  stores: any;
  storeByStoreId: any;
  storeIdByZone: any;
  storeIDByCity: any;
  storeIDByZoneCity: any;
  storeDetailByStoreId: any;
}

const initialState: IInitialState = {
  isAddingStore: false,
  isStoreAdded: false,
  isFetchingStores: false,
  isFetchingStoreDetails: false,
  addStoreMsg: '',
  stores: [],
  storeIdByZone: {},
  storeIDByCity: {},
  storeIDByZoneCity: {},
  storeByStoreId: {},
  storeDetailByStoreId: {},
};

export const counterSlice = createSlice({
  name: 'store',
  initialState,
  reducers: {
    updateStoreState: (state, action) => Object.assign(state, action.payload),
  },
  extraReducers: {
    [addStore.pending as any]: (state) => {
      state.isAddingStore = true;
      state.isStoreAdded = false;
    },
    [addStore.fulfilled as any]: (state, { payload }) => {
      state.isAddingStore = false;
      state.isStoreAdded = true;
      state.addStoreMsg = payload || '';
    },
    [addStore.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.isAddingStore = false;
      }
    },

    [getStores.pending as any]: (state) => {
      state.isFetchingStores = true;
    },
    [getStores.fulfilled as any]: (state, { payload }) => {
      state.isFetchingStores = false;

      const stores: any = [];
      const storeByStoreId = {};
      const storeIdByZone = {};
      const storeIDByCity = {};
      const storeIDByZoneCity = {};

      (payload?.data || []).forEach(store => {
        const keyValue: string = store.id;

        if (keyValue && !storeByStoreId[keyValue]) {
          const zone = camelCase(store.zone);
          const city = camelCase(store.city);
          stores.push(store);
          storeByStoreId[keyValue] = store;
          if (storeIdByZone[zone])
            storeIdByZone[zone].push(keyValue);
          else
            storeIdByZone[zone] = [keyValue];

          if (storeIDByCity[city])
            storeIDByCity[city].push(keyValue);
          else
            storeIDByCity[city] = [keyValue];

          const zoneCityKey = `${zone}:${city}`;
          if (storeIDByZoneCity[zoneCityKey])
            storeIDByZoneCity[zoneCityKey].push(keyValue);
          else
            storeIDByZoneCity[zoneCityKey] = [keyValue];
        }
      });

      state.stores = stores;
      state.storeByStoreId = storeByStoreId;
      state.storeIdByZone = storeIdByZone;
      state.storeIDByCity = storeIDByCity;
      state.storeIDByZoneCity = storeIDByZoneCity;
    },
    [getStores.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.isFetchingStores = false;
      }
    },

    [getStoresDetails.pending as any]: (state) => {
      state.isFetchingStoreDetails = true;
    },
    [getStoresDetails.fulfilled as any]: (state, { payload }) => {
      state.isFetchingStoreDetails = false;
      state.storeDetailByStoreId[payload.id] = payload || '';
    },
    [getStoresDetails.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.isFetchingStoreDetails = false;
      }
    },
  },
});

const { updateStoreState } = counterSlice.actions;
export {
  updateStoreState,
  addStore,
  getStores,
  getStoresDetails,
};
export default counterSlice.reducer;
